module.exports = __webpack_public_path__ + "static/media/halacious-OgvqXGL7XO4-unsplash.c738272a.jpg";